module.exports = __webpack_public_path__ + "img/logo-horizontal-white.4892c98.png";